export default __webpack_public_path__ + "static/media/image-change.3051c97c.jpg";